// ACCORDION / FAQs
//
//
//
//
//
//
export function initAccordion() {


    ///////////////////////////////////////////////
// ACCORDION / FAQs (GSAP)
////////////////////////////////////////////////

// Only initialize FAQ accordions if they exist on the page
if (document.querySelectorAll(".faq6_accordion").length > 0) {
    let faqslist = document.querySelectorAll(".faq6_accordion");
  
    faqslist.forEach(faq => {
        const question = faq.querySelector('.faqsquestion');
        const answer = faq.querySelector('.faqsanswer');
        const faqicon = faq.querySelector('.icon-embed-small');
  
        // Setzen Sie die Anfangshöhe der Antwort auf 0 und verstecken Sie sie
        gsap.set(answer, { height: '0px', overflow: 'hidden' });
        gsap.set(faqicon, { rotation: 0 });
  
        // Check if this accordion contains the anchor from URL hash
        if (window.location.hash) {
            const hash = window.location.hash.substring(1); // Remove the # symbol
            if (answer.querySelector(`#${hash}`) || answer.querySelector(`[id="${hash}"]`)) {
                gsap.to(answer, { height: answer.scrollHeight + 'px', duration: 0.3, ease: "power2.out" });
                gsap.to(faqicon, { rotation: 45, duration: 0.3, ease: "power2.out" });
                
                // Scroll to the anchor after accordion opens
                setTimeout(() => {
                    document.querySelector(`#${hash}`).scrollIntoView({ behavior: 'smooth' });
                }, 350);
            }
        }
  
        question.addEventListener('click', (e) => {
            e.preventDefault();
  
            // Antwort ein- oder ausblenden mit GSAP
            if (answer.style.height === '0px') {
                gsap.to(answer, { height: answer.scrollHeight + 'px', duration: 0.3, ease: "power2.out" });
                gsap.to(faqicon, { rotation: 45, duration: 0.3, ease: "power2.out" });
            } else {
                gsap.to(answer, { height: '0px', duration: 0.3, ease: "power2.out" });
                gsap.to(faqicon, { rotation: 0, duration: 0.3, ease: "power2.out" });
            }
        });
    });
  }
  



    // END OF MODULE
    console.log("Accordion initialized");
}